import { render } from "./Add-Patient.vue?vue&type=template&id=c75618d8&ts=true"
import script from "./Add-Patient.vue?vue&type=script&lang=ts"
export * from "./Add-Patient.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/dev.poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__